// bf-ingredient-grid-filters.js
//
// 0️⃣ Debug log at the top
//
console.log("✅ ingredient-filters.js loaded");

// ---------------------------
// Tooltip 50+ Terms Helper: normalize any "list" field into an array
function parseListField(val) {
  if (!val) return [];
  if (Array.isArray(val)) return val;
  if (typeof val === "string") {
    const s = val.trim();
    if (s.startsWith("[") && s.endsWith("]")) {
      try { return JSON.parse(s); } catch {}
    }
    return s.split(/[,·]/).map(x => x.trim()).filter(Boolean);
  }
  return [String(val)];
}

// ---------------------------
// Tooltip 50+ Terms Helper: build window.GLOSSARY from fetched terms
function buildGlossaryFromList() {
  return (window.GLOSSARY_LIST || []).reduce((acc, item) => {
    acc[item.handle] = {
      title: item.title           || item.handle,
      latin: item.latin_name      || "",
      desc:  item.description     || "",
      img:   item.thumb           || "",
      url:   item.learn_more      || "",
      perks: parseListField(item.skin_perks),
      aromatherapy: parseListField(item.aromatherapy),
      aroma_family: item.aroma_family || "",
      aroma_color: item.aroma_color   || "",
      purpose: parseListField(item.ingredient_function),
      used_in_many: item.used_in_many || false,
      related_products: item.related_products || []
    };
    return acc;
  }, {});
}


// ---------------------------
// Preloader helper: hides loader text and reveals the grid
function revealIngredients() {
  document.getElementById('ingredients-loader')?.classList.add('hidden');
  document.getElementById('ingredients-grid')?.classList.remove('hidden');
}

// ---------------------------
// 1️⃣ Loader: fetch paginated metaobjects, render grid, init filters and tooltips
async function loadFilters() {

  console.log("⚙️ loadFilters running…");
  console.log("Endpoint:", GLOSSARY_ENDPOINT);
  console.log("Token:",    GLOSSARY_TOKEN);

  try {
    const allTerms = [];
    let hasNextPage = true;
    let endCursor   = null;

    const query = `
      query Glossary($first: Int!, $after: String) {
        metaobjects(type: "glossary_term", first: $first, after: $after) {
          edges {
            node {
              handle
              titleVal: field(key: "title") { value }
              latin_name: field(key: "latin_name") { value }
              description: field(key: "description") { value }
              thumbRef: field(key: "thumb") { reference { __typename ... on MediaImage { image { url } } } }
              learn_more: field(key: "learn_more") { value }
              skin_perks: field(key: "skin_perks") { value }
              aromatherapy: field(key: "aromatherapy") { value }
              aroma_family: field(key: "aroma_family") { value }
              aroma_color: field(key: "aroma_color") { value }
              ingredient_function: field(key: "ingredient_function") { value }
              used_in_many: field(key: "used_in_many") { value }
              related_products: field(key: "related_products") {
                references(first: 10) {
                  nodes {
                    __typename
                    ... on Product { title, onlineStoreUrl }
                  }
                }
              }
            }
          }
          pageInfo { hasNextPage endCursor }
        }
      }
    `;

    while (hasNextPage) {
      const res = await fetch(GLOSSARY_ENDPOINT, {
        method:  'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': GLOSSARY_TOKEN
        },
        body: JSON.stringify({ query, variables: { first: 100, after: endCursor } })
      });

      const { data, errors } = await res.json();
      if (errors) throw new Error(JSON.stringify(errors));

      const { edges, pageInfo } = data.metaobjects;
      edges.forEach(({ node }) => {
        allTerms.push({
          handle:             node.handle,
          title:              node.titleVal?.value || node.handle,
          latin_name:         node.latin_name?.value || "",
          description:        node.description?.value || "",
          thumb:              node.thumbRef?.reference?.image?.url || "",
          learn_more:         node.learn_more?.value || "",
          skin_perks:         node.skin_perks?.value || [],
          aromatherapy:       node.aromatherapy?.value || [],
          aroma_family:       node.aroma_family?.value || "",
          aroma_color:        node.aroma_color?.value || "",
          ingredient_function: node.ingredient_function?.value || [],
          used_in_many:       node.used_in_many?.value || false,
          related_products:   (node.related_products?.references?.nodes || [])
                                .filter(n => n.__typename === 'Product')
                                .map(p => ({ title: p.title, url: p.onlineStoreUrl }))
        });
      });

      hasNextPage = pageInfo.hasNextPage;
      endCursor   = pageInfo.endCursor;
    }

    // Populate both data sources
    window.GLOSSARY_LIST = allTerms;
    window.GLOSSARY      = buildGlossaryFromList();
    console.log(`✅ Loaded ${allTerms.length} terms; built window.GLOSSARY with ${Object.keys(window.GLOSSARY).length} entries.`);

    // Render cards & filters
    renderCards();
    initFilters();

    // Initialize tooltips
    if (window.initGlossary) window.initGlossary();

  // ──> finally, show the grid now that everything’s rendered
  revealIngredients();

  }
  catch (err) {
    console.error("❌ Error fetching glossary via Storefront API:", err);
  }
}

//
// 2️⃣ Utility: Title-case slugs (e.g. "neem-oil" → "Neem Oil")
//
function titleCase(slug) {
  return String(slug)
    .replace(/-/g, " ")
    .replace(/\b\w/g, m => m.toUpperCase());
}

//
// 3️⃣ Helper: normalize any "list" field into an array
//
function parseListField(val) {
  if (!val) return [];
  if (Array.isArray(val)) return val;
  if (typeof val === "string") {
    const s = val.trim();
    if (s.startsWith("[") && s.endsWith("]")) {
      try { return JSON.parse(s); } catch {}
    }
    return s.split(/[,·]/).map(x => x.trim()).filter(Boolean);
  }
  return [String(val)];
}

//
// 4️⃣ Render ALL cards into the .bf-grid container
//
function renderCards() {
  const grid = document.querySelector(".bf-grid");
  if (!grid || !window.GLOSSARY_LIST) return;

  const terms = window.GLOSSARY_LIST.slice().sort((a, b) =>
    titleCase(a.title || a.handle).localeCompare(titleCase(b.title || b.handle))
  );

  grid.innerHTML = terms.map(item => {
    const perksStr   = parseListField(item.skin_perks).join(", ");
    const aromaStr   = parseListField(item.aromatherapy).join(", ");
    const funcsStr   = parseListField(item.ingredient_function).join(", ");
    const related    = item.related_products || [];
    const thumbUrl   = item.thumb || "";
    const titleText  = item.title || titleCase(item.handle);

    const dot = item.aroma_color
      ? `<span class="bf-card-aroma-dot" style="background:${item.aroma_color};"></span>`
      : "";

    return `
      <article class="bf-card" data-handle="${item.handle}">
        ${item.aroma_family
          ? `<p class="bf-card-aroma">${dot}${item.aroma_family}</p>` : ""}

        <img class="bf-card-img"
             src="${thumbUrl}"
             alt="${titleText}"
             loading="lazy"
             width="200" height="200" />

        <h5 class="bf-card-title">${titleText}</h5>

        ${item.latin_name
          ? `<p class="bf-card-latin"><em>${item.latin_name}</em></p>` : ""}

        ${perksStr
          ? `<p class="bf-card-perks"><span class="label">On Skin:</span> <span>${perksStr}</span></p>` : ""}

        ${aromaStr
          ? `<p class="bf-card-aromatherapy"><span class="label">Aroma:</span> <span>${aromaStr}</span></p>` : ""}

        ${funcsStr
          ? `<p class="bf-card-function"><span class="label">Role:</span> <span>${funcsStr}</span></p>` : ""}

        <hr/>

        ${item.used_in_many
          ? `<p class="bf-card-fallback"><span class="bf-card-many">Used in many products</span></p>`
          : (related.length
              ? `<ul class="bf-card-products">
                   ${related.slice(0,5).map(p => `<li><a href="${p.url}" target="_blank" rel="noopener">${p.title}</a></li>`).join("")}
                   ${related.length > 5 ? "<li>…</li>" : ""}
                 </ul>`
              : ""
            )
        }

        ${item.learn_more
          ? `<p class="bf-card-more"><a href="${item.learn_more}" class="bf-card-more-link">More Info →</a></p>`
          : ""}
      </article>
    `;
  }).join("");
}

//
// 5️⃣ Filtering logic
//
function initFilters() {
  const aromas   = new Set(),
        perks    = new Set(),
        purposes = new Set();

  window.GLOSSARY_LIST.forEach(item => {
    if (item.aroma_family) aromas.add(item.aroma_family);
    parseListField(item.skin_perks).forEach(p => perks.add(p));
    parseListField(item.ingredient_function).forEach(f => purposes.add(f));
  });

  function renderCheckboxes(containerId, values, className) {
    const container = document.getElementById(containerId);
    if (!container) return;
    container.innerHTML = "";
    Array.from(values).sort().forEach(v => {
      const label = document.createElement("label");
      Object.assign(label.style, {
        display: "inline-flex",
        alignItems: "center",
        marginRight: "8px",
        fontSize: ".85rem"
      });
      const cb = document.createElement("input");
      cb.type        = "checkbox";
      cb.className   = className;
      cb.value       = v;
      cb.style.marginRight = "4px";
      label.appendChild(cb);
      label.append(v);
      container.appendChild(label);
    });
  }

  renderCheckboxes("filter-aromas",    aromas,   "filter-aroma");
  renderCheckboxes("filter-perks",     perks,    "filter-perk");
  renderCheckboxes("filter-functions", purposes, "filter-function");

  const grid     = document.querySelector(".bf-grid"),
        cards    = grid ? Array.from(grid.children) : [],
        searchEl = document.getElementById("ingredient-search"),
        clearBtn = document.getElementById("clear-filters");

  function applyFilters() {
    const q = searchEl?.value.trim().toLowerCase() || "";
    const checkedAromas    = Array.from(document.querySelectorAll(".filter-aroma:checked")).map(cb => cb.value);
    const checkedPerks     = Array.from(document.querySelectorAll(".filter-perk:checked")).map(cb => cb.value);
    const checkedFunctions = Array.from(document.querySelectorAll(".filter-function:checked")).map(cb => cb.value);

    cards.forEach(card => {
      const title = (card.querySelector(".bf-card-title")?.textContent || "").toLowerCase();
      const data  = window.GLOSSARY_LIST.find(i => i.handle === card.dataset.handle) || {};

      const okSearch = !q || title.includes(q);
      const okAroma  = !checkedAromas.length    || checkedAromas.includes(data.aroma_family);
      const okPerk   = !checkedPerks.length     || parseListField(data.skin_perks).some(p => checkedPerks.includes(p));
      const okFunc   = !checkedFunctions.length || parseListField(data.ingredient_function).some(f => checkedFunctions.includes(f));

      card.style.display = (okSearch && okAroma && okPerk && okFunc) ? "" : "none";
    });

    const anyVisible = cards.some(c => c.style.display !== "none");
    grid?.classList.toggle("empty", !anyVisible);
    const noRes = document.querySelector(".no-results");
    if (noRes) noRes.style.display = anyVisible ? "none" : "block";
  }

  [searchEl, ...document.querySelectorAll(".filter-aroma, .filter-perk, .filter-function")]
    .filter(Boolean)
    .forEach(el => el.addEventListener("input", applyFilters));

  clearBtn?.addEventListener("click", () => {
    if (searchEl) searchEl.value = "";
    document.querySelectorAll(".filter-aroma, .filter-perk, .filter-function")
      .forEach(cb => cb.checked = false);
    applyFilters();
  });

  document.querySelectorAll(".bf-filter-group > strong").forEach(btn => {
    btn.addEventListener("click", () => {
      document.querySelectorAll(".bf-filter-group.open")
        .forEach(g => g !== btn.parentElement && g.classList.remove("open"));
      btn.parentElement.classList.toggle("open");
    });
  });

  document.addEventListener("click", e => {
    if (!e.target.closest(".bf-filter-group")) {
      document.querySelectorAll(".bf-filter-group.open").forEach(g => g.classList.remove("open"));
    }
  });

  applyFilters();
}

//
// ---------------------------
// 6️⃣ Invoke loader on page load & Shopify section load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadFilters);
} else {
  loadFilters();
}

document.addEventListener('shopify:section:load', loadFilters);

// Export loader for external tooltip script
window.loadFilters = loadFilters;
